import { makeStyles } from '@mui/styles'

const useBreadcrumbsStyles = makeStyles((theme) => ({
  breadcrumb: {
    fontSize: `
      clamp(
        ${theme.typography.pxToRem(6)}, 
        ${theme?.custom?.app.scaleFactor.large}, 
        ${theme.typography.pxToRem(20)}
      )
    `,
    lineHeight: 1,
    '& > ol': {
      alignItems: 'baseline',
    },
  },
  button: {
    marginLeft: `clamp(${theme.spacing(1)}, ${theme?.custom?.app.scaleFactor.default}, ${theme.spacing(2)})`,
  },
}))

export default useBreadcrumbsStyles
